import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    allowClear: false,
    placeholder: 'Select',
    tags: Boolean,
  };

  connect() {
    this.initSelect2();
    this.initEventListeners();
  }

  initSelect2() {
    $(this.element).select2({
      width: "100%",
      allowClear: this.allowClearValue,
      placeholder: this.placeholderValue,
      tags: true,
      tokenSeparators: [','],
      createTag: (params) => {
        const term = $.trim(params.term);
        if (term === '') return null;
  
        return {
          id: term,
          text: term,
          newTag: true
        };
      },
      templateResult: (data) => {
        if (data.newTag) {
          return $(`<span>Create "<strong>${data.text}</strong>"</span>`);
        }
        return data.text;
      },
      escapeMarkup: (markup) => markup
    });
  }

  initEventListeners() {
    const fireChangeEvent = () =>
      this.element.dispatchEvent(new Event("change"));

    const unSelectEvent = () =>
      this.element.dispatchEvent(new Event("change"));

    $(this.element).on("select2:select", fireChangeEvent);
    $(this.element).on("select2:unselecting", unSelectEvent);

    $(document).on("turbo:before-cache", () => {
      if ($(this.element).data("select2")) {
        $(this.element).select2("destroy");
      }
    });
  }
}
